<div class="filter-container">
  <form [formGroup]="filterForm" (ngSubmit)="applyFilters()">
    <div class="filter-section">

      <label for="site">{{ 'FILTER.LABEL.SITE' | translate }}</label>
      <!--div class="radio-group">
        <label>
          <input type="radio" formControlName="site" value="all" /> All
        </label>
        <label>
          <input type="radio" formControlName="site" value="assigned" /> Assigned
        </label>
        <label>
          <input type="radio" formControlName="site" value="unassigned" /> Unassigned
        </label>
      </div-->
      <input type="text" id="siteName" placeholder="{{ 'FILTER.PLACEHOLDER.SITE_NAME' | translate }}"
        formControlName="siteName" class="input-text" attr.aria-label="{{ 'FILTER.LABEL.SITE' | translate }}" />
    </div>

    <!--div class="filter-section">
      <label for="state">State</label>
      <div class="radio-group">
        <label>
          <input type="radio" formControlName="state" value="all" /> All
        </label>
        <label>
          <input type="radio" formControlName="state" value="connected" /> Connected
        </label>
        <label>
          <input type="radio" formControlName="state" value="disconnected" /> Disconnected
        </label>
      </div>
    </div-->

    <div class="filter-section">
      <label for="companyName">{{ 'FILTER.LABEL.COMPANY' | translate }}</label>
      <input type="text" id="companyName" placeholder="{{ 'FILTER.PLACEHOLDER.COMPANY_NAME' | translate }}"
        formControlName="companyName" class="input-text" attr.aria-label="{{ 'FILTER.LABEL.COMPANY' | translate }}" />
    </div>

    <div class="filter-section">
      <label for="modelName">{{ 'FILTER.LABEL.MODEL' | translate }}</label>
      <input type="text" id="modelName" placeholder="{{ 'FILTER.PLACEHOLDER.MODEL_NAME' | translate }}"
        formControlName="modelName" class="input-text" attr.aria-label="{{ 'FILTER.LABEL.MODEL' | translate }}" />
    </div>

    <div class="filter-section">
      <label>{{ 'FILTER.LABEL.LAST_USED_DATE' | translate }}</label>
      <div class="date-group">
        <input type="date" formControlName="lastUsedFrom"
          attr.aria-label="{{ 'FILTER.ARIA.LAST_USED_FROM' | translate }}" />
        <input type="date" formControlName="lastUsedTo"
          attr.aria-label="{{ 'FILTER.ARIA.LAST_USED_TO' | translate }}" />
      </div>
    </div>

    <div class="filter-section">
      <label>{{ 'FILTER.LABEL.LAST_CALIBRATION_DATE' | translate }}</label>
      <div class="date-group">
        <input type="date" formControlName="lastCalibrationFrom"
          attr.aria-label="{{ 'FILTER.ARIA.LAST_CALIBRATION_FROM' | translate }}" />
        <input type="date" formControlName="lastCalibrationTo"
          attr.aria-label="{{ 'FILTER.ARIA.LAST_CALIBRATION_TO' | translate }}" />
      </div>
    </div>

    <div class="d-flex gap-2">
      <button type="button" (click)="resetFilters()"
        class="btn btn-light btn-sm border-color-button flex-fill d-flex align-items-center justify-content-center"
        attr.aria-label="{{ 'BUTTONS.RESET' | translate }}">
        <i class="fas fa-redo me-2"></i>
        {{ 'BUTTONS.RESET' | translate }}
      </button>
      <button type="submit"
        class="btn btn-light btn-sm colored-button flex-fill d-flex align-items-center justify-content-center"
        attr.aria-label="{{ 'BUTTONS.APPLY' | translate }}">
        {{ 'BUTTONS.APPLY' | translate }}
      </button>
    </div>

  </form>
</div>